import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import StatusBadge from "../../../Components/UI/statusBadge";
import TableActions from "../../../Components/UI/table/TableActions";
import { deletePromotion, updatePromotion } from "../../../MyApi/promotions";
import { getPromotionsAPI } from "../../../MyApi/promotions";
import AddModalPromotion from "../addmodalpromotion";
import Can from "../../../utils/can";
import { formatPrice } from "../../../utils/formatPrice/index";
import i18next from "i18next";

const PromotionsTab = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [promotionModalMode, setPromotionModalMode] = useState("create");
  const [promotionId, setPromotionId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const handleShowPromotion = (id) => {
    setPromotionId(id);
    setPromotionModalMode("show");
    setIsModalOpen(true);
  };

  const handleEditPromotion = (id) => {
    setPromotionId(id);
    setPromotionModalMode("edit");
    setIsModalOpen(true);
  };

  const promotionsColumns = [
    { label: "الاسم", accessor: "title" },
    { label: "الوصف", accessor: "description" },
    { label: "النوع", accessor: "type" },
    { label: "النوع الفرعي", accessor: "sub_type" },
    { label: "تاريخ البداية", accessor: "start_date" },
    { label: "تاريخ النهاية", accessor: "end_date" },
    { label: "عدد الاستخدامات", accessor: "usage_limit" },
    { label: "الحد الأدنى للطلب", render:(row)=><div> {formatPrice(row.currency_factor, row.min_order_amount) }</div>  },
    { label: "الخصم", render: (row) => {
      if (row.sub_type === "percentage_discount") {
        return <div className="text-green">{formatPrice(row.currency_factor, row.discount_value)}%</div>;
      } else if (row.sub_type === "fixed_price") {
        return <div className="text-green">{formatPrice(row.currency_factor, row.discount_value)}</div>;
      } else if (row.sub_type === "free_delivery") {
        return <div className="text-green">توصيل مجاني</div>;
      }
      return <div>{formatPrice(row.currency_factor, row.discount_value)}</div>;
    }},
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={() => handleShowPromotion(row.id)}
          viewPermission={"view_promotion"}
          edit={() => handleEditPromotion(row.id)}
          editPermission={"update_promotion"}
          deleteFn={deletePromotion}
          deletePermission={"delete_promotion"}
          id={row.id}
          queryKey={"getPromotions"}
          is_active={row.is_active}
          togglePermission={"update_promotion"}
          toggleMutationKey={"toggle-update-promotion"}
          toggleFn={(id, status) => updatePromotion(id, {
            is_active: status,
            _method: "PUT",
            lang: i18next.language
          })}
        />
      ),
    },
  ];

  const {
    data: promotionsData,
    isLoading: promotionsLoading,
    refetch,
    error,
  } = useQuery(["getPromotions", currentPage], () => getPromotionsAPI("", currentPage));

  const promotions = promotionsData?.data?.promotions || [];
  const total = promotionsData?.data?.pagination?.total || 0;
  const last_page = promotionsData?.data?.pagination?.last_page || 0;

  return (
    <>
      <Can permission={"view_promotion"}>
        <DataTable
          columns={promotionsColumns}
          data={promotions}
          title="العروض الترويجية"
          actionLabel="إضافة عرض ترويجي جديد"
          onAddClick={() => {
            setPromotionModalMode("create");
            setPromotionId(null);
            setIsModalOpen(true);
          }}
          isLoading={promotionsLoading}
          createPermission={"create_promotion"}
          totalItems={total}
          itemsPerPage={last_page}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          error={error}
          onRetry={() => refetch()}
        />
      </Can>
      <AddModalPromotion
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setPromotionModalMode("create");
          setPromotionId(null);
        }}
        refetch={refetch}
        mode={promotionModalMode}
        promotionId={promotionId}
      />
    </>
  );
};

export default PromotionsTab;